module.exports = __webpack_public_path__ + "files/84ec3f605e86aa66727f810dbb87d5a5.png";